// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"38e801a3","729":"4674f32c"}[chunkId] + ".css";
};